import { atom } from 'recoil';

export const completedActionsSearch = atom({
  key: 'completedActionsSearch',
  default: '',
});
